import { useCallback, useEffect, Suspense } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOkta } from '../hooks/oktaHook';
import { getUrlWithParams } from './Utils';

const PrivateRoutes = ({ children, accessScope }) => {
  const { authState, authenticate, userDetails } = useOkta();
  const locationOrg = useLocation();
  const location = useLocation();
  const navigate = useNavigate();

  const loginUser = useCallback(() => {
    const query = new URLSearchParams(locationOrg.search);
    const error = query.get('error');
    if (locationOrg.pathname !== '/403' && error !== 'access_denied') {
      authenticate();
    }
  }, [locationOrg.search, locationOrg.pathname, authenticate]);
  const bu = localStorage.getItem('bu_name');
  useEffect(() => {
    if (!(authState?.isAuthenticated ?? false)) {
      loginUser();
    } else {
      if (location.pathname === '/' || location.pathname === '/logout') {
        // Redirect to home if already authenticated
        navigate(getUrlWithParams('/home', bu));
      }
    }
  }, [authState?.isAuthenticated, loginUser, navigate, location.pathname]);

  if (!(authState?.isAuthenticated ?? false)) {
    return <>Redirecting to Login Page...</>;
  }

  const userRoles = userDetails?.roles;

  // Authorization check redirect to 403 page , if don't have required role /permission
  if (!userRoles.some((role) => accessScope.includes(role))) {
    return <div>Access Denied</div>;
  }
  return <Suspense>{children}</Suspense>;
};

export default PrivateRoutes;
